import { ContentWrapper, Close, Backdrop, Content, Title, Subtitle, Option, OptionList, RadioCircle, RadioCircleInner, Back } from "./ProductModal.style";

export interface ProductModalOption {
  title: string;
  occupation: string;
}

interface ProductModalProps {
  href: string | undefined;
  title: string;
  subtitle: string;
  options?: ProductModalOption[];
  onClose?: () => void;
  onOptionSelect?: (option: ProductModalOption) => void;
}

export default function ProductModal({ href, title, subtitle, options, onClose, onOptionSelect }: ProductModalProps) {
    const handleOptionClick = (option: ProductModalOption) => {
        console.log("Option clicked:", option);
        if (href) {
            if(option.occupation !== "student" && option.occupation !== "selfemployed") {
                window.location.href = `${href}&type=${option.occupation}`;
            } else {
                onOptionSelect?.(option);
            }
        }
    }

    return (
        <>
        <Backdrop onClick={onClose}>
            <Content onClick={(e) => e.stopPropagation()}>
                <Close>
                    <Back onClick={onClose} />
                </Close>
                <ContentWrapper>
                    <Title>{title}</Title>
                    <Subtitle>{subtitle}</Subtitle>
                    {options && (
                    <OptionList>
                        {options.map((option, index) => (
                            <Option key={index} onClick={() => handleOptionClick(option)}>
                                <RadioCircle>
                                    <RadioCircleInner />
                                </RadioCircle>
                                {option.title}
                            </Option>
                        ))}
                    </OptionList>
                    )}
                </ContentWrapper>
            </Content>
        </Backdrop>
    </>
    );
}